export enum USER_ROLES {
  PORTAL_ADMIN = 'Portal Admin',
  PORTAL_USER = 'Portal User',
}
